import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import {
  CreateClassBaseRequest, Base, ClassBase, ClassBaseKey, BaseKey, UpdateBaseRequest
} from './base.types';

export const useGetBases = () => {
  return useQuery({
    queryKey: ['getBases'],
    queryFn: () =>
        apiClient.get<Base[]>('/bases')
  });
}
  
export const useGetBase = (
    {
      baseId
    }: BaseKey
) => {
  return useQuery({
    queryKey: ['getBase', baseId],
    queryFn: () =>
        apiClient.get<Base>(`/bases/${baseId}`)
  });
};

export const useUpdateBase = (
    {
        baseId
    }: BaseKey
) => {
  return useMutation({
    mutationKey: ['updateBase', baseId],
    mutationFn: (request: UpdateBaseRequest) =>
        apiClient.put<Base>(`/bases/${baseId}`, request)
  });
};

export const useDeleteBase = (
    {
      baseId
    }: BaseKey
) => {
  return useMutation({
    mutationKey: ['deleteBase', baseId],
    mutationFn: () =>
        apiClient.delete(`/bases/${baseId}`)
  })
}

export const useGetClassBases = (
  requestBody: {
    classNo?: string;
    baseNo?: string;
    status?: number
  },
  enabled: boolean = true
) => {
  return useQuery<AxiosResponse<ClassBase[]>>({
    queryKey: ['bases', requestBody.classNo, requestBody.baseNo, requestBody.status],
    queryFn: () => apiClient.get<ClassBase[]>('/class-bases', { params: requestBody }),
    enabled
  });
};

export const useCreateClassBase = () => {
  return useMutation({
    mutationKey: ['createClassBase'],
    mutationFn: ( request: CreateClassBaseRequest ) =>
        apiClient.post<ClassBase>(`/classes/${request.classId}/bases`, request.body)
  })
};

export const useDeleteClassBase = () => {
  return useMutation({
    mutationKey: ['deleteClassBase'],
    mutationFn:(request: ClassBaseKey) =>
        apiClient.delete(`/classes/${request.classId}/bases/${request.baseId}`),
  });
};

export const useGetRecipeBases = (
    requestBody: { classNo: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getRecipeBases', requestBody.classNo],
    queryFn: () => apiClient.get<Base[]>('/recipes/bases', { params: requestBody }),
    enabled
  });
};

export const useGetSubRecipeBases = (
    requestBody: { classNo: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getSubRecipeBases', requestBody.classNo],
    queryFn: () => apiClient.get<Base[]>('/sub-recipes/bases', { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemRecipeBases = (
    menuNo: string,
    requestBody: { classNo?: number; strategyNo?: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getMenuItemRecipeBases', menuNo, requestBody.classNo, requestBody.strategyNo],
    queryFn: () => apiClient.get<Base[]>(`/menus/${menuNo}/items/recipes/bases`, { params: requestBody }),
    enabled
  });
};

export const useGetMenuItemSubRecipeBases = (
  menuNo: string,
  requestBody: { classNo?: number },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Base[]>>({
    queryKey: ['getMenuItemSubRecipeBases', menuNo, requestBody.classNo],
    queryFn: () => apiClient.get<Base[]>(`/menus/${menuNo}/items/sub-recipes/bases`, { params: requestBody }),
    enabled
  });
};
